// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { getAuthToken } from "../utils/auth";
import { api } from "./authService";
import { TGetTransactionResponses, TGetTransactionsParams } from '@/types/transactions/transaction-types';
import { constructUrl } from '@/utils/construct-url';
import { getParams } from '@/utils/get-param-util';
import { transactions } from './endpoints';

// eslint-disable-next-line no-unused-vars
const API_URL = import.meta.env.VITE_APP_API_URL || "";

// eslint-disable-next-line no-unused-vars
const headers = () => ({
  Authorization: `ClientBearer ${getAuthToken()}`,
});

export const getTransactions = async (params = {}) => {
  try {
    // Convert params object to URLSearchParams
    const searchParams = new URLSearchParams();

    // Process params according to the API documentation
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        // Handle special cases for some parameters
        if (key === "status" || key === "payment_type") {
          // These should already be comma-separated strings from the Dashboard component
          searchParams.append(key, value as string);
        } else {
          // For standard parameters
          searchParams.append(key, value as string);
        }
      }
    });

    // Log the final search params for debugging
    console.log("API request params:", searchParams.toString());

    const response = await api.get(
      `/admin/transactions?${searchParams.toString()}`
    );

    // Log the raw response for debugging
    console.log("Raw API Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};

export const getTransactionById = async (id: string) => {
  try {
    const response = await api.get(`/admin/transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching transaction details:", error);
    throw error;
  }
};

export const updateTransactionStatus = async (
  id: string,
  action: string,
  declineReason: string | null = null
) => {
  try {
    const requestBody: any = { action };
    if (declineReason) {
      requestBody.decline_reason = declineReason;
    }
    
    const response = await api.patch(`/admin/transactions/${id}`, requestBody);
    return response.data;
  } catch (error) {
    console.error("Error updating transaction status:", error);
    throw error;
  }
};

// Mark cash as ready for pickup
export const markCashReady = async (id: string) => {
  try {
    const response = await api.patch(`/admin/transactions/${id}`, {
      action: "mark-cash-ready"
    });
    return response.data;
  } catch (error) {
    console.error("Error marking cash ready:", error);
    throw error;
  }
};

// Mark cash as collected with disbursement code
export const markCashCollected = async (id: string, disbursementCode: string) => {
  try {
    const response = await api.patch(`/admin/transactions/${id}`, {
      action: "mark-cash-collected",
      disbursement_code: disbursementCode
    });
    return response.data;
  } catch (error) {
    console.error("Error marking cash collected:", error);
    throw error;
  }
};

// Same as the getTransactions endpoint above but it is typed
export const getUserTransactions = async (param?: TGetTransactionsParams): Promise<TGetTransactionResponses> => {
  let params;
  let url;
  if (param) {
    params = getParams<TGetTransactionsParams>(param);
  }
  url = params ? constructUrl(`${transactions}`, params) : transactions;

  try {
    const response = await api.get<TGetTransactionResponses>(url);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
}
